import React from "react";
import lipsHCLogo from "./../../../../../Assets/lipsHCLogo.svg";
import { IoIosCheckmarkCircle } from "react-icons/io";
import CustomAction from "./../../../../../Components/controls/CustomAction";
import { motion } from "framer-motion";

export default function VNLeftContent({ mainColor, handleNextStep }) {
  return (
    <div className="inner-content vn-left">
      <div className="content">
        <motion.div initial="initial" animate="animate">
          <motion.h2
            className="heading"
            style={{
              color: mainColor,
              display: "inline-block",
            }}
          >
            {"Booking your travel vaccines is quick and easy!"
              .split(" ")
              .map((word, index) => (
                <motion.span
                  key={index}
                  style={{ display: "inline-block", marginRight: "6px" }}
                  initial={{ y: "100%", opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{
                    ease: "easeOut",
                    duration: 0.35,
                    delay: index * 0.03,
                  }}
                >
                  {word}
                </motion.span>
              ))}
          </motion.h2>
        </motion.div>

        <motion.div className="desc" initial="initial" animate="animate">
          <motion.p
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              ease: "easeOut",
              duration: 0.35,
              delay: 0.2,
            }}
          >
            To secure your appointment, here's what you'll need:
          </motion.p>
        </motion.div>

        <motion.div
          className="list-container"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                delayChildren: 0.5,
                staggerChildren: 0.15,
              },
            },
          }}
        >
          {[
            {
              title: "Your Name and Email",
              description: "So we can send your confirmation",
            },
            {
              title: "Where You're Traveling",
              description: "We'll tailor your vaccines to your destination",
            },
            {
              title: "Date and Time for Your Appointment",
              description: "Pick a slot that works for you",
            },
            {
              title: "Payment for Your Booking Deposit",
              description: "Secure your appointment instantly",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              className="box"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1, delay: 5 }}
              transition={{
                ease: "easeOut",
                duration: 0.4,
                delay: 0.5 + index * 0.15,
              }}
            >
              <IoIosCheckmarkCircle color={mainColor} size={20} />
              <div>
                <p>{item.title}</p>
                <p className="lighter">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
      <CustomAction
        text="Sounds good!"
        action={() => {
          handleNextStep();
        }}
        mainColor={mainColor}
      />
    </div>
  );
}
